export default "__VITE_ASSET__YGPp2wM8__"